import React from 'react';
import { CheckCircle2Icon, AlertCircleIcon, XCircleIcon, ClockIcon, Loader2Icon } from 'lucide-react';
export type StatusType = 'success' | 'warning' | 'error' | 'pending' | 'in-progress';
interface StatusBadgeProps {
  status: StatusType;
  label?: string;
  className?: string;
}
export function StatusBadge({
  status,
  label,
  className = ''
}: StatusBadgeProps) {
  const config = {
    success: {
      colors: 'bg-pk-success-light text-pk-success border-pk-success/20',
      icon: CheckCircle2Icon,
      defaultLabel: 'Success'
    },
    warning: {
      colors: 'bg-pk-amber-light text-pk-amber border-pk-amber/20',
      icon: AlertCircleIcon,
      defaultLabel: 'Warning'
    },
    error: {
      colors: 'bg-pk-error-light text-pk-error border-pk-error/20',
      icon: XCircleIcon,
      defaultLabel: 'Error'
    },
    pending: {
      colors: 'bg-muted text-muted-foreground border-border',
      icon: ClockIcon,
      defaultLabel: 'Pending'
    },
    'in-progress': {
      colors: 'bg-pk-info-light text-pk-info border-pk-info/20',
      icon: Loader2Icon,
      defaultLabel: 'In Progress'
    }
  };
  const {
    colors,
    icon: Icon,
    defaultLabel
  } = config[status];
  const displayLabel = label || defaultLabel;
  return <span className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium border ${colors} ${className}`} data-id="element-187">
      <Icon className={`w-3.5 h-3.5 ${status === 'in-progress' ? 'animate-spin' : ''}`} data-id="element-188" />
      {displayLabel}
    </span>;
}